angular
.module('avant.scripts', [])
.directive('avScript', ->
  return {
    restrict: 'A',
    scope:
      avScript: '@'
      content: '='
      callback: '&'
    template: '<script type="{{avScript}}"></script>'
    link: (scope, elem, attrs) ->
      scope.$watch('content', (newVal, oldVal) ->
        return unless newVal
        elem.find('script').text(scope.content)
        scope.callback()
      )
  }
)
